module.exports = __webpack_public_path__ + "img/ao.64f72a94.svg";